import { memo } from "react";

const AppOfficeLocationIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_8450_11310)">
				<path d="M9.60986 11.35C9.60986 11.67 9.85986 11.93 10.1699 11.93H11.0799C10.4099 10.63 9.86986 9.32 9.67986 8.25C9.63986 8.33 9.60986 8.42 9.60986 8.52V11.35Z" fill="#3069B2" />
				<path
					d="M10.9502 7.54002C10.9502 9.83002 14.5802 15.21 14.9902 15.81C15.1002 15.97 15.2802 16.06 15.4702 16.06C15.6602 16.06 15.8402 15.96 15.9502 15.81C16.3602 15.2 19.9902 9.83002 19.9902 7.54002C19.9902 5.05002 17.9602 3.02002 15.4702 3.02002C12.9802 3.02002 10.9502 5.05002 10.9502 7.54002ZM18.8302 7.54002C18.8302 8.97002 16.7202 12.51 15.4702 14.43C14.2202 12.51 12.1102 8.97002 12.1102 7.54002C12.1102 5.69002 13.6202 4.18002 15.4702 4.18002C17.3202 4.18002 18.8302 5.69002 18.8302 7.54002Z"
					fill={color}
				/>
				<path
					d="M13.48 7.59998C13.48 8.69998 14.38 9.59998 15.48 9.59998C16.58 9.59998 17.48 8.69998 17.48 7.59998C17.48 6.49998 16.58 5.59998 15.48 5.59998C14.38 5.59998 13.48 6.49998 13.48 7.59998ZM16.31 7.59998C16.31 8.05998 15.94 8.42998 15.48 8.42998C15.02 8.42998 14.65 8.05998 14.65 7.59998C14.65 7.13998 15.02 6.76998 15.48 6.76998C15.94 6.76998 16.31 7.13998 16.31 7.59998Z"
					fill={color}
				/>
				<path
					d="M8.32998 3.12999C8.32998 2.80999 8.07998 2.54999 7.76998 2.54999H5.03998C4.72998 2.54999 4.47998 2.80999 4.47998 3.12999V5.95999C4.47998 6.27999 4.72998 6.53999 5.03998 6.53999H7.76998C8.07998 6.53999 8.32998 6.27999 8.32998 5.95999V3.12999ZM7.20998 5.38999H5.58998V3.70999H7.20998V5.38999Z"
					fill={color}
				/>
				<path
					d="M7.76998 7.94H5.03998C4.72998 7.94 4.47998 8.2 4.47998 8.52V11.35C4.47998 11.67 4.72998 11.93 5.03998 11.93H7.76998C8.07998 11.93 8.32998 11.67 8.32998 11.35V8.52C8.32998 8.2 8.07998 7.94 7.76998 7.94ZM7.20998 10.77H5.58998V9.09H7.20998V10.77Z"
					fill={color}
				/>
				<path
					d="M17.38 18.58H15.91V17.35C15.77 17.38 15.62 17.4 15.47 17.4C15.23 17.4 15.01 17.34 14.79 17.26V18.57H11.98V14.05C11.98 13.73 11.73 13.47 11.42 13.47H6.5C6.19 13.47 5.94 13.73 5.94 14.05V18.57H3.13V1.16H14.78V1.71C15 1.68 15.23 1.67 15.46 1.67C15.61 1.67 15.75 1.68 15.9 1.69V0.58C15.9 0.26 15.65 0 15.34 0H2.59C2.28 0 2.03 0.26 2.03 0.58V18.58H0.56C0.25 18.58 0 18.84 0 19.16C0 19.48 0.25 19.74 0.56 19.74H17.39C17.7 19.74 17.95 19.48 17.95 19.16C17.95 18.84 17.7 18.58 17.39 18.58H17.38ZM10.87 18.58H7.07V14.64H10.87V18.58Z"
					fill={color}
				/>
				<path
					d="M10.7299 4.09999V3.70999H11.0399C11.4299 3.25999 11.8799 2.86999 12.3899 2.54999H10.1699C9.85986 2.54999 9.60986 2.80999 9.60986 3.12999V5.95999C9.60986 6.08999 9.65986 6.20999 9.72986 6.30999C9.89986 5.49999 10.2499 4.74999 10.7199 4.08999L10.7299 4.09999Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_8450_11310">
					<rect width="22" height="22" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default memo(AppOfficeLocationIcon);
